import { useState } from 'react'
import { newHttpService } from '../../services/new-http-service'
import { SystemTable } from '../../cmps/system/system-table'
import { SystemFormModal } from '../../cmps/system/system-form-modal'
import { Spinner } from '../../cmps/util-cmps/spinner'
import { useCachedFetch } from '../../hooks/use-cached-fetch'

const GET_SYSTEMS = `
{
  systems{
    id
    name
    abbreviation
    logoUrl
    type
    createdAt
  }
}
`

export const SystemsPage: React.FC = () => {
    const { data, isLoading, hasError, refetch } = useCachedFetch(
        'systems',
        async () => {
            const result = await newHttpService.graphql('auditech', GET_SYSTEMS)
            return result.systems as any[]
        }
    )

    const [isModalOpen, setIsModalOpen] = useState(false)
    const [systemToEdit, setSystemToEdit] = useState<any>(null)

    const openCreateModal = () => {
        setSystemToEdit(null)
        setIsModalOpen(true)
    }

    const openEditModal = (system: any) => {
        setSystemToEdit(system)
        setIsModalOpen(true)
    }

    const closeModal = () => {
        setIsModalOpen(false)
        setSystemToEdit(null)
    }

    const handleSuccess = () => {
        closeModal()
        refetch()
    }

    return <div className="tablePageContainer">
        <div className="page-header">
            <p className="tableSubtitle">Manage source systems and integrations.</p>
            <button className="add-btn" onClick={openCreateModal}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="12" y1="5" x2="12" y2="19" />
                    <line x1="5" y1="12" x2="19" y2="12" />
                </svg>
                Create System
            </button>
        </div>
        {isLoading && <Spinner />}
        {!isLoading && !hasError && <SystemTable data={data || []} onEditClick={openEditModal} />}
        {!isLoading && hasError && <div className="error-hint">Failed to load data. Try refreshing the page or re-logging in.</div>}

        {isModalOpen && <SystemFormModal
            key={systemToEdit?.id || 'create'}
            systemToEdit={systemToEdit}
            existingTypes={Array.from(new Set((data || []).map((s: any) => s.type).filter(Boolean)))}
            existingNames={(data || []).map((s: any) => s.name)}
            onSuccess={handleSuccess}
            onClose={closeModal}
        />}
    </div>
}
